import { Fragment } from 'react';

import NoticeModal from '#src/components/NoticeModal';

import { useDescriptionModal } from '../helpers';

import styles from './styles.module.scss';

export const GameDescription = ({ description, theme, title }) => {
  const { hide, show, visible } = useDescriptionModal();

  return (
    <Fragment>
      <p
        className={styles.description}
        dangerouslySetInnerHTML={{ __html: description }}
        onClick={show}
      />
      <NoticeModal
        visible={visible}
        onClose={hide}
        content={{ title, ctaLabel: 'Close' }}
        theme={theme}
      >
        <p
          className={styles.modalDescription}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </NoticeModal>
    </Fragment>
  );
};
